export const colors = {
  white: '#FFFFFF',
  white_1: '#FFFFFF0D',
  white_30: '#FFFFFF4D',
  white_90: '#FFFFFFE6',
  red: '#aa0707',
  grey_1: '#DDDDDD26',
  grey_200: '#AFAFAF',
  black_1: '#00000066',
  black_second: '#1B1B1B',
  black_99: '#0C0B0B99',
  silver: '#D9D9D9',
  myta: '#4554E5',
  blue_second: '#4272DE',
};
